import { render } from "./ConfettiCanvas.vue?vue&type=template&id=0fa29608&scoped=true"
import script from "./ConfettiCanvas.vue?vue&type=script&lang=js"
export * from "./ConfettiCanvas.vue?vue&type=script&lang=js"

import "./ConfettiCanvas.vue?vue&type=style&index=0&id=0fa29608&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa29608"]])

export default __exports__